import { baseAPI } from "../baseApi"

export const analyticsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение группировок для типа объектов
        fetchGroupingFilters: builder.query<any, any>({
            query: (args) => ({
                url: `reports/aggregate/groupings?ClassId=${args.filterClassId}`
            })
        }),
        // запрос на получение фильтров для типа объекта
        fetchAggregateFilters: builder.query<any, any>({
            query: (args) => ({
                url: `reports/aggregate/filters`
            })
        }),
        // запрос на получение значений для конкретного фильтра
        fetchFilterValues: builder.query<any, any>({
            query: (args) => ({
                url: `reports/aggregate/filterValues?FilterID=${args.filterId}`
            })
        }),
        // запрос на получение данных составленного отчета
        fetchAnalyticsReport: builder.query<any, any>({
            query: (args) => ({
                url: `reports/aggregate/execute?ClassID=${args.classId}`
                    + `${args.groupId ? `&GroupID=${args.groupId}` : ''}`
                    + `${args.aggregateFilterId ? `&FilterID=${args.aggregateFilterId}` : ''}`
                    + `${args.aggregateFilterValues ? `&FilterValues='${args.aggregateFilterValues}'` : ''}`
                    + `${args.roadOptionsUrl ? args.roadOptionsUrl : ''}`
            })
        }),
    })
})

export const {
    useFetchGroupingFiltersQuery,
    useFetchAggregateFiltersQuery,
    useLazyFetchFilterValuesQuery,
    useFetchAnalyticsReportQuery,
    useLazyFetchAnalyticsReportQuery,
    useLazyFetchGroupingFiltersQuery
} = analyticsApiSlice


